import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Grid,
  Paper
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { postData, putData } from '../utils/helper';
import { PropagateLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom';

const CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

const EmployeesForm = () => {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    email: '',
    phone: '',
    grade: '',
    appointment_date: '',
    position: '',
    bank_name: '',
    account_title: '',
    iban: '',
    cnic: '',
    basic_salary: ''
  });
  const navigate = useNavigate();
  const rowData = useLocation().state?.editData || {};
  const [isEditMode] = useState(!!rowData.id);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  let [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    if (formData.code === '' || formData.name === '' || formData.email === '' || formData.phone === '' || formData.grade === '' || formData.basic_salary === '' || formData.appointment_date === '' || formData.position === '' || formData.bank_name === '' || formData.account_title === '' || formData.iban === '') {
      toast.error('Please fill all fields', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      setLoading(false);
    } else {
      let response;
      if (isEditMode) {
        response = await putData('employees/' + rowData.id, formData);
      } else {
        response = await postData('employees', formData);
      }
      if (response.status === 401) {
        navigate('/', { state: { message: "Session Expired" } });
        setLoading(false);
        return;
      }
      setLoading(false);
      if (response.status === undefined) {
        toast.success('Data Save Successfully', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setFormData({
          code: '',
          name: '',
          email: '',
          phone: '',
          grade: '',
          basic_salary: '',
          appointment_date: '',
          position: '',
          bank_name: '',
          account_title: '',
          iban: '',
          cnic: ''
        });
      } else {
        toast.error(JSON.stringify(response?.data?.errors), {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    }
  };

  useEffect(() => {
    if (rowData) {
      setFormData({
        code: rowData.code || '',
        name: rowData.name || '',
        email: rowData.email || '',
        phone: rowData.phone || '',
        grade: rowData.grade || '',
        basic_salary: rowData.basic_salary || '',
        appointment_date: rowData.appointment_date || '',
        position: rowData.position || '',
        bank_name: rowData.bank_name || '',
        account_title: rowData.account_title || '',
        iban: rowData.iban || '',
        cnic: rowData.cnic || ''
      });
    }
  }, []);



  return (
    <>
      {loading && (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)', // Optional: semi-transparent white background
          zIndex: 9999, // Ensure it's above other elements
        }}>
          <PropagateLoader
            color="#00BFFF"
            loading={loading}
            cssOverride={CSSProperties}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom align="center">
            Employee Form
          </Typography>
          <ToastContainer />
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={3}>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="code"
                  name="code"
                  label="Employee Code"
                  value={formData.code}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="name"
                  name="name"
                  label="Name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="cnic"
                  name="cnic"
                  label="CNIC"
                  placeholder="XXXXX-XXXXXXX-X"
                  value={formData.cnic}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="phone"
                  name="phone"
                  label="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="grade"
                  name="grade"
                  label="Grade"
                  value={formData.grade}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="appointment_date"
                  name="appointment_date"
                  label="Appointment Date"
                  type="date"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData.appointment_date}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={6}>
                <TextField
                  fullWidth
                  id="position"
                  name="position"
                  label="Position"
                  value={formData.position}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={4}>
                <TextField
                  fullWidth
                  id="bank_name"
                  name="bank_name"
                  label="Bank Name"
                  value={formData.bank_name}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={4}>
                <TextField
                  fullWidth
                  id="account_title"
                  name="account_title"
                  label="Account Title"
                  value={formData.account_title}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={4}>
                <TextField
                  fullWidth
                  id="iban"
                  name="iban"
                  label="IBAN"
                  placeholder="PKXX XXXX XXXX XXXX XXXX XXXX"
                  value={formData.iban}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item size={12}>
                <TextField
                  fullWidth
                  id="basic_salary"
                  name="basic_salary"
                  label="Basic Salary"
                  value={formData.basic_salary}
                  onChange={handleChange}
                  type="number"
                  inputProps={{
                    min: "0",
                    step: "1"
                  }}
                  InputProps={{
                    startAdornment: <Typography sx={{ mr: 1 }}>Rs</Typography>,
                  }}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item size={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  sx={{
                    backgroundColor: '#00BFFF',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#009ACD', // darker shade for hover
                    }
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default EmployeesForm;